import {
  DEFAULT_TRUNCATION_MODE,
  DEFAULT_VALUE_REPRESENTATION,
  defaultRatio,
  SCALE_FALLBACK_COLOR,
} from '../../core/constants.js';
import {
  HistogramChartConfigProperties,
  HistogramChartLegendConfig,
  HistogramChartToolbarProps,
  HistogramChartXAxisConfig,
  HistogramChartYAxisConfig,
  HistogramThresholdsConfig,
  HistogramTooltipVariant,
} from '../types/histogram.js';

export const DEFAULT_CHART_HEIGHT = 300;
export const DEFAULT_LOADING_STATE = false;

export const defaultLegend: HistogramChartLegendConfig = {
  hidden: false,
  position: 'auto',
  ratio: defaultRatio,
};
export const defaultColorPalette = 'categorical';
export const DEFAULT_SCALE_FALLBACK_COLOR = SCALE_FALLBACK_COLOR;
export const defaultTooltipVariant: HistogramTooltipVariant = 'single';

export const defaultToolbarPlacement = 'top-right';
export const defaultToolbar: HistogramChartToolbarProps = {
  placement: defaultToolbarPlacement,
  enabled: false,
};

export const defaultHistogramChartConfig: HistogramChartConfigProperties = {
  valueRepresentation: DEFAULT_VALUE_REPRESENTATION,
  legend: defaultLegend,
  colorPalette: defaultColorPalette,
  tooltip: {
    variant: defaultTooltipVariant,
  },
  truncationMode: DEFAULT_TRUNCATION_MODE,
};

export const defaultYAxis: HistogramChartYAxisConfig = {};
export const defaultXAxis: HistogramChartXAxisConfig = {
  scale: 'linear',
};

export const defaultThreshold: HistogramThresholdsConfig = {
  leftThreshold: [],
  rightThreshold: [],
};

export const HISTOGRAM_CHART_ARIA_LABEL = 'Histogram Chart';
